import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { buildMonthCells } from "@/lib/calendar/mobile-agenda";
import type { CalendarEvent } from "@/components/calendar/views/CalendarEventTypes";

type Props = {
  selected: Date;
  today: Date;
  grouped: Map<string, CalendarEvent[]>;
  onSelectDay: (date: Date) => void;
};

export function MobileMonthView({ selected, today, grouped, onSelectDay }: Props) {
  const { t } = useTranslation("calendar");
  const cells = buildMonthCells(selected, grouped, today);
  const weekdays = t("mobile.weekdaysShort", { returnObjects: true }) as string[];

  return (
    <div className="rounded-3xl border border-border/60 bg-card p-3 shadow-sm">
      <div className="mb-1 grid grid-cols-7">
        {weekdays.map((wd, i) => (
          <span key={i} className="text-center text-[10px] font-bold uppercase tracking-wide text-muted-foreground">
            {wd}
          </span>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-0.5">
        {cells.map((cell, i) => (
          <button
            key={i}
            type="button"
            disabled={cell.faded}
            aria-pressed={cell.selected}
            onClick={() => onSelectDay(cell.date)}
            className={cn(
              "flex h-11 flex-col items-center gap-1 rounded-xl pt-1.5",
              cell.faded && "cursor-default",
              cell.selected && "bg-primary",
              !cell.selected && cell.isToday && "bg-primary/10",
            )}
          >
            <span
              className={cn(
                "text-[13px] font-semibold leading-none",
                cell.selected ? "text-primary-foreground" : cell.faded ? "text-muted-foreground/50" : cell.isToday ? "text-primary" : "text-foreground",
              )}
            >
              {cell.day}
            </span>
            <span className="flex h-[5px] items-center gap-0.5">
              {cell.dotColors.map((color, di) => (
                <span
                  key={di}
                  className="h-[5px] w-[5px] rounded-full"
                  style={{ backgroundColor: cell.selected ? "hsl(var(--primary-foreground))" : color }}
                />
              ))}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
